import { Card, Grid, Typography, useTheme } from "@mui/material";
import React from "react";

import TodaysCandidateFollowup from "./candidate-followups/TodaysCandidateFolloup";
import TomorrowsCandidateFollowup from "./candidate-followups/TomorrowsCandidateFollowups";
import RegisteredCandidate from "./RegisteredCandidate";

const Dashboard = () => {
  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RegisteredCandidate />
        </Grid>
        <Grid item xs={12}>
          <TodaysCandidateFollowup />
        </Grid>
        <Grid item xs={12}>
          <TomorrowsCandidateFollowup />
        </Grid>
      </Grid>
    </>
  );
};

export default Dashboard;
